import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {DialogProps} from 'packages/common-types/base-types';

type Props = DialogProps & {
  onSaveAndConfirm: () => void;
};

const ConfirmNextRound = (props: Props) => {
  const {toggle, modalOpen, onSaveAndConfirm} = props;

  return (
    <Dialog open={modalOpen} onClose={toggle} aria-labelledby="dialog-logout">
      <DialogTitle id="dialog-title">
        ¿Estas seguro de que deseas pasar a la siguiente ronda?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Primero asegurate de haber llenado toda la información de la mesa y
          verificar que los resultados estén correctos.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggle} color="default">
          Cancel
        </Button>
        <Button onClick={onSaveAndConfirm} color="primary">
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmNextRound;
